import Vue from 'vue'

import './styles/quasar.sass'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/material-icons/material-icons.css'
import Quasar from 'quasar/src/vue-plugin.js';import Notify from 'quasar/src/plugins/Notify.js';import Loading from 'quasar/src/plugins/Loading.js';import QSpinnerOrbit from 'quasar/src/components/spinner/QSpinnerOrbit.js';

Vue.use(Quasar, {
  framework: {
    cssAddon: true,
  },
  config: {
    brand: {
      primary: "#384b66",
      secondary: "#2655a6",
      accent: "#9295a8",
      dark: "#1d1d1d",
      positive: "#089c2a",
      negative: "#b33d4a",
      info: "#384b66",
      warning: "#F2C037",
    },
    loading: {
      spinner: QSpinnerOrbit,
      spinnerColor: 'grey-8',
      spinnerSize: 100,
      backgroundColor: 'white',
    },
    breakpoints: {
      xs: 601,
      sm: 1025,
      md: 1441,
      lg: 1921,
      xl: Infinity,
    },
  },
  plugins: {
    Notify,
    Loading,
  }
})